module.exports = __webpack_public_path__ + "img/bg-center.21224eca.png";